import { ProductGuideLanguageListNode } from "../../../apiHooks";
import { BulletedList } from "../../../components/BulletedList";
import { Typography } from "../../../components/Typography";
import { useNextTranslation } from "../../../hooks";
import { ListItem } from "../ListItem";
import { ProductSectionTitle } from "../ProductSectionTitle";
import { ProductSectionWrapper, ProductSectionWrapperProps } from "./ProductSectionWrapper";

type ProductGuideLanguagesSectionProps = Omit<ProductSectionWrapperProps, "children"> & {
    guideLanguages: ProductGuideLanguageListNode[];
};
export const ProductGuideLanguagesSection = ({ guideLanguages, ...props }: ProductGuideLanguagesSectionProps) => {
    const [t] = useNextTranslation("product");

    return (
        <ProductSectionWrapper {...props} data-testid="product-guide-languages-section">
            <ProductSectionTitle data-ref="product-guide-languages-title">
                {t("label.guideLanguages")}
            </ProductSectionTitle>
            <ProductGuideLanguages guideLanguages={guideLanguages} />
        </ProductSectionWrapper>
    );
};

export const ProductGuideLanguages = ({
    guideLanguages,
}: {
    guideLanguages: ProductGuideLanguagesSectionProps["guideLanguages"];
}) => {
    return (
        <BulletedList data-testid="product-guide-languages">
            {guideLanguages.map((addition, idx) => (
                <ListItem key={idx}>
                    <Typography color="subtle" size="large">
                        {addition.name}
                    </Typography>
                </ListItem>
            ))}
        </BulletedList>
    );
};
